import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function App({ allData }) {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
        text: "Capex vs Opex",
      },
    },
    scales: {
      x: {
        color: "#d7d7d7",
        ticks: {
          precision: 0,
          color: "#d5d5d5",
        },
        title: {
          display: true,
          color: "#d7d7d7",
          text: "Year",
        },
        stacked: true,
      },
      y: {
        color: "#d7d7d7",
        ticks: {
          precision: 0,
          color: "#d5d5d5",
        },
        title: {
          display: true,
          color: "#d7d7d7",
          text: "Amount (USD)",
        },
        stacked: true,
      },
    },
  };

  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "CAPEX",
        data: [],
        backgroundColor: "rgb(255, 99, 132)",
        stack: "stack0",
      },
      {
        label: "OPEX",
        data: [],
        backgroundColor: "rgb(75, 192, 192)",
        stack: "stack1",
      },
    ],
  });
  useEffect(() => {
    const labels = [];
    const opex = [];
    const capex = [];
    allData.map((i) => {
      labels.push(i.year);
      opex.push(i.opex);
      capex.push(i.capex);
    });
    const newData = {
      labels,
      datasets: [
        {
          label: "CAPEX",
          data: capex,
          backgroundColor: "rgb(255, 99, 132)",
          stack: "stack0",
        },
        {
          label: "OPEX",
          data: opex,
          backgroundColor: "rgb(75, 192, 192)",
          stack: "stack1",
        },
      ],
    };
    setData(newData);
  }, [allData]);
  return (
    <div style={{ position: "relative", height: "434px", width: "100%" }}>
      <Bar options={options} data={data} />
    </div>
  );
}

export default App;
